import type { SpeechEngineResult } from './speechEngine';

export interface VoiceDictation {
  base: string;
  finals: string;
  interim: string;
}

function appendSpeech(text: string, speech: string): string {
  const addition = speech.trim();
  if (!addition) return text;
  if (!text || /\s$/.test(text)) return text + addition;
  return `${text} ${addition}`;
}

export function startDictation(base: string): VoiceDictation {
  return { base, finals: '', interim: '' };
}

export function applySpeechResult(dictation: VoiceDictation, result: SpeechEngineResult): VoiceDictation {
  if (result.isFinal) {
    return { ...dictation, finals: appendSpeech(dictation.finals, result.transcript), interim: '' };
  }
  return { ...dictation, interim: result.transcript.trim() };
}

export function dictationText(dictation: VoiceDictation): string {
  return appendSpeech(appendSpeech(dictation.base, dictation.finals), dictation.interim);
}

export function rebaseDictation(dictation: VoiceDictation, text: string): VoiceDictation {
  const { interim } = dictation;
  if (!interim || !text.endsWith(interim)) return startDictation(text);
  const withoutInterim = appendSpeech(dictation.base, dictation.finals);
  const separator = dictationText(dictation).slice(withoutInterim.length, -interim.length);
  const base = text.slice(0, -interim.length);
  return startDictation(separator && base.endsWith(separator) ? base.slice(0, -separator.length) : base);
}
